module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/vol-off-29fd93af.svg";